import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

import { mutateInterop } from '@confluence/apollo-relay-interop/entry-points/mutate.ts';

import type { WhiteboardExtensionCreateWhiteboardMutation$data } from './__generated__/WhiteboardExtensionCreateWhiteboardMutation.graphql.ts';
import { CreateWhiteboardMutation } from './WhiteboardExtensionCreateWhiteboard.graphql.ts';
import { getFullWhiteboardUrl } from './urls.ts';

type CreatedWhiteboardData = {
	contentId: string;
	fullUrl: string;
};

export async function createWhiteboardOverGraphQL(
	pageId: string,
	spaceId: string,
	spaceKey: string,
	templateKey: string,
	createAnalyticsEvent: CreateUIAnalyticsEvent | undefined,
): Promise<CreatedWhiteboardData> {
	const mutationResult = await mutateInterop<WhiteboardExtensionCreateWhiteboardMutation$data>({
		mutation: CreateWhiteboardMutation,
		variables: { createdInContentId: pageId, spaceKey },
	});

	const contentId = mutationResult.data?.createContentInline?.id;
	if (!contentId) {
		throw Error('no content id present');
	}

	// track event - whiteboard created inline
	const event = createAnalyticsEvent?.({
		type: 'sendTrackEvent',
		data: {
			action: 'createdByFlow',
			actionSubject: 'content',
			objectType: 'whiteboard',
			objectId: contentId,
			containerType: 'space',
			containerId: spaceId,
			source: 'createContentHandler',
			attributes: {
				flow: 'inlineWhiteboardCreation',
				contentType: 'whiteboard',
				collabService: 'canvas-relay',
				templateKey,
			},
		},
	});
	event?.fire();

	// return full URL so user can navigate
	return { contentId, fullUrl: getFullWhiteboardUrl(contentId, spaceKey) };
}
